import { formatCurrency, formatNumber } from '@utils'
import cn from 'clsx'

import Pagination from '@components/shared/Pagination'
import { formatDate } from '@/utils/date'

const CheckProductionTable = ({
    className,
    rows,
    pageCount,
    itemsPerPage,
    setPageIndex,
}) => {
    
    return (
        
        <div className={cn('CheckProductionTable', className)}>
            
            <table className="mt-4 table-auto table-sticky-headers">
                <thead>
                    <tr>
                        <th>Month</th>
                        <th>Product</th>
                        <th>Production Volume</th>
                        <th>Owner Volume</th>
                        <th>Weighted Average Price</th>
                        <th>Owner Gross Value</th>
                        <th>Owner Adjustments</th>
                        <th>Owner Net Value</th>
                    </tr>
                </thead>
                <tbody>
                    {rows?.map((it, idx) => (
                        <tr key={idx}>
                            <td>{formatDate(it.salesDate, 'MMM, YYYY') || <span className="text-muted">N/A</span>}</td>
                            <td>{it.productionType}</td>
                            <td>{formatNumber(it.propertyVolumeSum)}</td>
                            <td>{formatNumber(it.ownerVolumeSum)}</td>
                            <td>{formatCurrency(it.weightedAvg)}</td>
                            <td>{formatCurrency(it.gross)}</td>
                            <td>{formatCurrency(it.adjustments)}</td>
                            <td>{formatCurrency(it.net)}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
            
            <div className="flex justify-center px-3 pt-3 pb-4">
                <Pagination
                    count={pageCount}
                    itemsPerPage={itemsPerPage}
                    setPageIndex={setPageIndex} />
            </div>
        
        </div>
        
    )
    
}

export default CheckProductionTable
